import axios from 'axios'
const { get, post, patch } = axios
import { assembleForm } from 'apps/builder/lib/transforms'

const getToken = () => document.querySelector('[name="csrf-token"]').content
const buildHeaders = () => ({
  headers: {
    'Content-Type': 'application/json',
    'X-CSRF-Token': getToken(),
  },
})

// Need to revisit once we move builder 3 over to main to decide best way to handle duplicate but different routes

export const builderFetch = url => get(url, buildHeaders())

export const fetchAppDefinition = appId =>
  builderFetch(`/forms/${appId}/form_definition.json`)

export const fetchReadOnlyAppDefinition = appId =>
  builderFetch(`/forms/${appId}/form_read_only_definition.json`)

export const fetchEntryTypes = () =>
  builderFetch(`/entry_types/builder_types.json`)

export const fetchWebFormEntryTypes = () =>
  builderFetch(`/entry_types/web_form_builder_types.json`)

export const fetchConditionTypes = () =>
  builderFetch('/condition_types.json')

export const fetchOperationTypes = () =>
  builderFetch('/operation_types.json')

export const pingServerRequest = appId =>
  builderFetch(`/app-builder/ping.json?form_id=${appId}`)

export const fetchReferenceData = appId =>
  !appId || appId === 0
    ? builderFetch(`/api/v3/reference_data`)
    : builderFetch(`/api/v3/reference_data?form_id=${appId}`)

export const fetchReferenceImages = () =>
  builderFetch('/reference_images.json')

export const saveAppRequest = (appId, entities, folder_id) => {
  const data = assembleForm(entities)

  return post(
    `/forms/${appId}/app_definition_update.json${folder_id ? `?folder_id=${folder_id}` : ''
    }`,
    data,
    buildHeaders()
  )
}

export const onboardingSaveAppRequest = (appId, entities) => {
  const data = assembleForm(entities)
  return post(
    `/app-builder/forms/${appId}/onboarding_store_app_definition.json`,
    data,
    buildHeaders()
  )
}

export const publishAppRequest = (appId, data) =>
  patch(`/forms/${appId}/publish.json`, data, buildHeaders())

export const fetchAppSettings = appId =>
  builderFetch(`/forms/${appId}/form_settings.json`)

export const updateFTUX = () =>
  post(
    `/app-builder/update-ftux`,
    {
      closed_ftux_video: true,
    },
    buildHeaders()
  ).catch(e => e)

export const fetchUserForms = department_id => department_id ? builderFetch(`/api/v3/forms?department_id=${department_id}`) : builderFetch(`/api/v3/forms`) 

export const fetchForm = form_id => builderFetch(`/api/v3/forms/${form_id}?format=flat`)

export const fetchLiveDataSources = departmentId =>
  builderFetch(`/api/v3/live_data_sources?status=published&department_id=${departmentId}`)